import React from 'react';
import { IgSheet, confirmer } from '../ig/IgSheet';
import { toast } from 'sonner';
import './objet-menu.css';

/* LOT 81 - Bloc 4 : le menu (...) de chaque objet.
   Format impose : feuille blanche, lignes grises avec fleche, petit sous-texte gris, "Demander a {expert}" en bas (deja automatique via IgSheet).
   actions = [{ key, label, sub, Icon, onClick, danger, disabled, testId }] */
export const ObjetMenuSheet = ({ open, onClose, titre, kicker, actions, z, testId }) => {
  if (!open) return null;
  return (
    <IgSheet open onClose={onClose} title={titre} kicker={kicker} testId={testId} {...(z ? { z } : {})}>
      <div className="omn-lst">
        {actions.filter(Boolean).map((a) => (
          <button
            key={a.key}
            type="button"
            className="omn-r"
            disabled={a.disabled}
            onClick={a.onClick}
            style={a.danger ? { color: 'var(--p-b3261e, #B3261E)' } : undefined}
            data-testid={a.testId}
          >
            {a.Icon && <i><a.Icon size={18} /></i>}
            <span className="omn-r-txt">
              <b>{a.label}</b>
              {a.sub && <small>{a.sub}</small>}
            </span>
            <span className="omn-ch">{'>'}</span>
          </button>
        ))}
      </div>
    </IgSheet>
  );
};

/* LOT 81 - Bloc 4 fin : suppression VRAIMENT différée. L'objet est masqué tout de suite (onMasquer),
   mais l'appel réel au serveur n'a lieu qu'après 5 s sans « Annuler » : rien n'est donc jamais perdu
   tant que les 5 s ne sont pas écoulées, ses liaisons (stock, prix, cartes, planning...) restent intactes
   puisqu'elles n'ont encore jamais bougé côté serveur. « Annuler » annule juste le minuteur et remet l'objet. */
export const supprimerAvecAnnuler = async ({ titre, consequence, onMasquer, onAnnuler, appelSuppression, succes = 'Supprimé', echec = 'Impossible pour le moment' }) => {
  const ok = await confirmer({ title: titre, message: consequence, okLabel: 'Supprimer' });
  if (!ok) return false;
  onMasquer?.();
  let annule = false;
  const minuteur = setTimeout(() => {
    if (annule) return;
    appelSuppression().catch((e) => {
      onAnnuler?.();
      toast.error(e?.response?.data?.detail || echec);
    });
  }, 5000);
  toast.success(succes, {
    duration: 5000,
    action: { label: 'Annuler', onClick: () => { annule = true; clearTimeout(minuteur); onAnnuler?.(); } },
  });
  return true;
};

